<template>
    <div class="main-container" style="background-color: #f0f6fa;width: 100vw;">
        <!-- 页面顶部内容 -->
        <div style="position: relative;">
            <img src="@/images/introuBannan.png" style="width: 100vw;height: 30.21vw;">
            <div class="topTitle">
                见心即安心
            </div>
            <div class="topText">
                您的情绪管理帮办！心理装备专家！
            </div>
        </div>
        <!-- 关于见心部分 -->
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.56vw">
                <div style="margin-bottom:0.52vw;padding-top:3.59vw;">
                    关于见心
                </div>
                <div style="font-weight: 400;font-size: 0.73vw;color: #7ED0FF;">
                    About FOHEART
                </div>
            </div>
            <div class="jianxinCss">
                <img src="@/images/introImg1.png" style="width: 29.11vw;height:19.48vw;margin-right: 2.08vw;">
                <div style="min-height: 19.48vw;width: 34.48vw;">
                    <div>
                        见心心理（湖南见心科技有限公司，前身为湖南图斯心理咨询有限公司，已成立 11
                        年），专注于心理健康领域的整体解决方案，包括产品研发、销售、人才培训以及社会服务。我们力求让每个人都能轻松获得科学的心理健康支持。<br>
                        我们的主要客户是学校。我们为学校提供全面的心理健康服务体系，帮助学生们培养积极的心态。此外，我们也为社区、医院、公安部队等机构提供专业的心理健康服务，服务网络遍布全国。<br>
                        我们坚信预防和干预同等重要。因此，我们不仅关注问题的解决，也注重心理健康的普及与教育。我们不断创新，开发新的技术和产品，推动心理健康行业的发展。<br>
                        我们有一支专门的心理软件研发队伍，并与经验丰富的心理学专家和一线教师合作，将先进的心理科学转化为实际可用的产品和服务。我们始终关注客户的需求，提供专业、高效且可靠的心理健康解决方案，助力各个领域提升心理健康水平。
                    </div>
                </div>
            </div>
        </div>
        <!-- 品牌文化部分 -->
        <div class="boxOne" style="padding-bottom: 2.083vw;">
            <div class="TitleCss" style="margin-bottom:1.56vw">
                <div style="margin-bottom:0.52vw;padding-top:2.60vw;">
                    品牌文化
                </div>
                <div style="font-weight: 400;font-size: 0.73vw;color: #7ED0FF;">
                    Brand culture
                </div>
            </div>
            <div class="box2Css" style="margin-left: 3.65vw;margin-right: 3.65vw;">
                <div style="position: relative;margin-right: 0.78vw;margin-bottom: 0.78vw;">
                    <img src="@/images/introImg2.png" style="width: 28.12vw;height: 12.5vw;">
                    <div style="position: absolute;left: 2.66vw;top: 2.08vw;width: 22.60vw;">
                        <div class="box2TitleCss">
                            企业使命
                        </div>
                        <div class="box2TipCss">
                            Mission
                        </div>
                        <div class="box2TextCss">
                            通过科学的心理健康服务，为个体提供心理支持，助其建立积极心态，实现自我成长和社会和谐。
                        </div>
                    </div>
                </div>
                <div style="position: relative;margin-right: 0.78vw;margin-bottom: 0.78vw;">
                    <img src="@/images/introImg3.png" style="width: 28.12vw;height: 12.5vw;">
                    <div style="position: absolute;left: 2.66vw;top: 2.08vw;width: 22.60vw;">
                        <div class="box2TitleCss">
                            企业精神
                        </div>
                        <div class="box2TipCss">
                            Spirit
                        </div>
                        <div class="box2TextCss">
                            人才第一 追求第一 <br>引领变革 团结拼搏 共存共赢
                        </div>
                    </div>
                </div>
                <img src="@/images/introImg4.png"
                    style="width: 7.81vw;height: 12.5vw;margin-right: 0px;margin-bottom: 0.78vw;">
                <div style="position: relative;margin-right: 0.78vw;margin-bottom: 0.78vw;">
                    <img src="@/images/introImg5.png" style="width: 65.62vw;height: 12.5vw;">
                    <div style="position: absolute;left: 2.66vw;top: 2.08vw;width: 59.95vw;">
                        <div class="box2TitleCss">
                            企业愿景
                        </div>
                        <div class="box2TipCss">
                            Vision
                        </div>
                        <div class="box2TextCss">
                            让科学的心理健康服务触手可及，惠及每一个人，无论是在学校、社区还是其他工作环境中，都能够享受到专业、便捷的心理健康支持。见心就是放心，我们希望通过我们的服务，让每个人都能安心、放心。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 我们的优势部分 -->
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.56vw">
                <div style="margin-bottom:0.52vw;padding-top:3.59vw;">
                    公司优势
                </div>
                <div style="font-weight: 400;font-size: 0.73vw;color: #7ED0FF;">
                    Company advantages
                </div>
            </div>
            <div class="jianxinCss">
                <img src="@/images/imtorImg6.png" style="width: 29.11vw;height:19.48vw;margin-right: 2.08vw;">
                <div style="min-height: 19.48vw;width: 34.48vw;font-weight: 500;font-size: 1.04vw;">
                    <div>
                        在为大众提供疗愈和心理咨询时，需要扎实的研究和丰富的经验积累。目前市场上的疗愈项目种类繁多，几乎任何与感官体验相关的活动都被标榜为“疗愈”，各种活动究竟能带来什么样的疗愈效果？适用于哪些人群？这些问题在市场上并没有明确的答案，反映了结构化知识和明确目标群体定位的缺失。
                    </div>
                    <div style="margin-top: 0.78vw;">
                        在这种情况下，我们提供系统化和标准化的产品，确保每个步骤都有明确的目标和结果。我们深知疗愈不仅仅是表面的感觉体验，更需要科学的支持和系统的规划。
                    </div>
                    <div style="margin-top: 0.78vw;">
                        因此，我们的疗愈项目基于严格的研究和临床验证，确保每一种疗愈手段都有科学依据。
                    </div>
                </div>
            </div>
        </div>
        <!-- 公司优势部分 -->
        <div
            style="background-color: #f0f6fa;text-align: center;display: flex;justify-content: center;padding-bottom: 2.89vw;">
            <div class="box2Css" style="margin-top: 2.89vw;justify-content: space-between;width: 72.92vw;">
                <div style="position: relative;">
                    <img src="@/images/intImg1.png" style="width: 33.7708vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">科学研究与验证</div>
                        <div>
                            我们的产品基于严格的心理学研究和临床验证，确保每一种疗愈手段都有科学依据。
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <img src="@/images/intImg2.png" style="width: 33.7708vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">系统化与标准化</div>
                        <div>
                            我们提供系统化和标准化的产品，确保每个步骤都有明确的目标和结果。<br> 每种疗愈手段都有详细的适用人群指导，确保精准匹配。
                        </div>
                    </div>
                </div>
                <div style="position: relative;margin-top: 2.89vw;">
                    <img src="@/images/intImg3.png" style="width: 33.7708vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">专业团队支持</div>
                        <div>
                            我们拥有一支由心理学专家和技术研发人员组成的精英团队，确保每项服务的专业性和有效性。<br> 团队成员具备丰富的理论与实践经验，能够为
                        </div>
                    </div>
                </div>
                <div style="position: relative;margin-top: 2.89vw;">
                    <img src="@/images/intImg4.png" style="width: 33.7708vw;">
                    <div class="boxTwoCss">
                        <div class="boxTitleCss">针对性与个性化</div>
                        <div>
                            针对不同的个体和情况，我们提供量身定制的疗愈方案。<br> 通过专业评估，为每位客户推荐最适合的疗愈方式。
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'introducePage',
    data() {
        return {}
    }
}
</script>

<style lang="less" scoped>
.boxOne {
    width: 72.92vw;
    margin: 0 auto;
    min-height: 33.59vw;
    background: #fff;
    border-radius: 1.04vw;
    margin-top: 2.89vw;
}

.TitleCss {
    margin: 0 auto;
    text-align: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.88vw;
    color: #0093E8;
}

.jianxinCss {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 0.94vw;
    color: #666666;
    line-height: 1.88vw;
    margin-bottom: 5.21vw;
    flex-wrap: wrap;
    padding-bottom: 1.04vw;
}

.box2Css {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.topTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 3.44vw;
    color: #FEFEFC;
    line-height: 7.29vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    background: -webkit-linear-gradient(0deg, #41B9FF 0%, #0093E8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: absolute;
    left: 21.15vw;
    top: 10.57vw;
}

.topText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 1.46vw;
    color: #444444;
    line-height: 7.29vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    position: absolute;
    left: 21.15vw;
    top: 15vw;
}

.boxTwoCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 0.89vw;
    color: #666666;
    width: 23.91vw;
    position: absolute;
    left: 8.9166vw;
    top: 3.0729vw;
    text-align: left;
}

.boxTitleCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 600;
    font-size: 1.35vw;
    color: #323232;
    margin-bottom: 1.25vw;
}

.box2TitleCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 1.46vw;
    color: #0093E8;
    margin-bottom: 0.10vw;
}

.box2TipCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 0.94vw;
    color: #7ED0FF;
    margin-bottom: 1.56vw;
}

.box2TextCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 0.99vw;
    color: #666666;
}

/* 媒体查询，针对移动端 */
@media (max-width: 768px) {
    .main-container {
        /* 计算缩放比例 */
        transform-origin: top left;
        transform: scale(calc(100vw / 1920));
        width: 1920px;
        /* 避免缩放后出现滚动条 */
        overflow-x: hidden;
    }

    /* 调整绝对定位元素的位置 */
    .topTitle {
        left: calc(21.15vw * (100vw / 1920));
        top: calc(10.57vw * (100vw / 1920));
    }

    .topText {
        left: calc(21.15vw * (100vw / 1920));
        top: calc(15vw * (100vw / 1920));
    }

    .boxTwoCss {
        left: calc(10.62vw * (100vw / 1920));
        top: calc(3.91vw * (100vw / 1920));
    }
}
</style>